import Vue from 'vue';
import DataLayer from '@fi/utils/DataLayer';

Vue.prototype.$dataLayer = DataLayer;
